window.hoculus ||= {};
hoculus.utils = {
    getScriptAsync:async (source) => {
        hoculus.loadedScripts = hoculus.loadedScripts || [];
        return await new Promise(function (resolve, reject) {
            if (hoculus.loadedScripts.includes(source)) {
                resolve(true);
            } else {
                var script = document.createElement("script");
                var prior = document.getElementsByTagName("script")[0];
                script.defer = 1;

                script.onload = script.onreadystatechange = function (_, isAbort) {
                    if (
                        isAbort ||
                        !script.readyState ||
                        /loaded|complete/.test(script.readyState)
                    ) {
                        script.onload = script.onreadystatechange = null;
                        script = undefined;

                        if (!isAbort) setTimeout(resolve(true), 0);
                    }
                };

                script.src = source;
                prior.parentNode.insertBefore(script, prior);
            }
        });
    },
    addToCart: (items) => {
        return new Promise(function (resolve, reject) {
            var postData = JSON.stringify({items:items})
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: postData
            }).then(response => {
                return response.json();
            }).then(data => {
                if(data.status == 422) resolve(false)
                    resolve(data);
            }).catch((error) => {
                    console.error('Error:', error);
                    reject(error)
            });
        })
    },
    insertCss: function (css) {
		var link = document.createElement("link");
		link.setAttribute("rel", "stylesheet");
		link.setAttribute("href", css);
		document.head.appendChild(link);
	},
    getScript: function (source, callback) {
		var script = document.createElement("script");
		var prior = document.getElementsByTagName("script")[0];
		script.defer = 1;

		script.onload = script.onreadystatechange = function (_, isAbort) {
			if (
				isAbort ||
				!script.readyState ||
				/loaded|complete/.test(script.readyState)
			) {
				script.onload = script.onreadystatechange = null;
				script = undefined;

				if (!isAbort && callback) setTimeout(callback, 0);
			}
		};

		script.src = source;
		prior.parentNode.insertBefore(script, prior);
	},
	getScriptAsync: async function (source) {
		hoculus.loadedScripts = hoculus.loadedScripts || [];
		return await new Promise(function (resolve, reject) {
			if (hoculus.loadedScripts.includes(source)){
				resolve(true)
			}else{
				var script = document.createElement("script");
				var prior = document.getElementsByTagName("script")[0];
				script.defer = 1;

				script.onload = script.onreadystatechange = function (_, isAbort) {
					if (
						isAbort ||
						!script.readyState ||
						/loaded|complete/.test(script.readyState)
					) {
						script.onload = script.onreadystatechange = null;
						script = undefined;

						if (!isAbort) setTimeout(resolve(true), 0);
					}
				};

				script.src = source;
				prior.parentNode.insertBefore(script, prior);
			}
		});
	},
    domready: (callback) => {
        if (document.readyState == "complete") callback();
        else document.addEventListener("DOMContentLoaded", callback);
    },
    onLoad: async () => {
        Promise.allSettled([
            hoculus.slick(),
            hoculus.whatsappWidget()
        ])
    }
};


hoculus.slick = () => {
    var wrapper = $(".halo-block-content.home-collections"),
    productGrid = wrapper.find('.products-carousel'),
    itemToShow = productGrid.data('item-to-show'),
    itemDots = productGrid.data('item-dots'),
    itemDotsMb = productGrid.data('item-dots-mb'),
    itemArrows = productGrid.data('item-arrows'),
    itemArrowsMb = productGrid.data('item-arrows-mb');


    if(productGrid.length > 0) {
        if(productGrid.not('.slick-initialized')) {
            productGrid.slick({
                mobileFirst: true,
                adaptiveHeight: true,
                vertical: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: itemArrowsMb,
                dots: itemDotsMb,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                rtl: window.rtl_slick,
                responsive: 
                [
                    {
                        breakpoint: 1599,
                        settings: {
                            arrows: itemArrows,
                            dots: itemDots,
                            get slidesToShow() {
                                if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                    return this.slidesToShow = itemToShow;
                                } else {
                                    return this.slidesToShow = 1;
                                }
                            },
                            get slidesToScroll() {
                                if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                    return this.slidesToScroll = itemToShow;
                                } else {
                                    return this.slidesToScroll = 1;
                                }
                            }
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            arrows: itemArrows,
                            dots: itemDots,
                            get slidesToShow() {
                                if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                    if(itemToShow == 5){
                                        return this.slidesToShow = itemToShow - 1;
                                    } else {
                                        return this.slidesToShow = itemToShow;
                                    }
                                } else {
                                    return this.slidesToShow = 1;
                                }
                            },
                            get slidesToScroll() {
                                if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                    if(itemToShow == 5){
                                        return this.slidesToScroll = itemToShow - 1;
                                    } else {
                                        return this.slidesToScroll = itemToShow;
                                    }
                                } else {
                                    return this.slidesToScroll = 1;
                                }
                            }
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: itemArrowsMb,
                            dots: itemDotsMb,
                            slidesToShow: 4,
                            slidesToScroll: 4
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            arrows: itemArrowsMb,
                            dots: itemDotsMb,
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 320,
                        settings: {
                            arrows: itemArrowsMb,
                            dots: itemDotsMb,
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }
                ]
            });
        }
    }
}

hoculus.whatsappWidget = function () {
    // hoculus.utils.getScript(hoculus.assets.js.jquery,init)
    init();
    function init () {
        const selector = "#whatsapp-button"
        console.log("~~~ ", $(selector).length)
        if(!$(selector).length) return;

		const node = $(selector)
		const options = node.data("whatsappSettings")
		hoculus.utils.insertCss(hoculus.themeData.floatingWppCss);
		hoculus.utils.getScript(hoculus.themeData.floatingWppJs,function(){
			node.floatingWhatsApp(options);
			node.show();
		});
    }
}

hoculus.utils.domready(hoculus.utils.onLoad);